import axios from '../utils/axios';

export const createComment = async (productId, data) =>
  await axios.post(`${process.env.REACT_APP_API}/comment/product/${productId}`, data);

export const getComments = async (productId) =>
  await axios.get(`${process.env.REACT_APP_API}/comments/product/${productId}`);

export const deleteComment = async (commentId) =>
  await axios.delete(`${process.env.REACT_APP_API}/comment/${commentId}`);

export const updateComment = async (commentId, data) =>
  await axios.put(`${process.env.REACT_APP_API}/comment/${commentId}`, data);

const commentService = {
  createComment,
  getComments,
  deleteComment,
  updateComment,
};

export default commentService;
